import DropdownMenu from "../../molecules/DropDownMenu";
import HeaderTimer from "../../molecules/HeaderTimer"
import { shortenText } from "@/lib/utils";
import { ChevronDownIcon } from "@radix-ui/react-icons";
import Badge from "@/components/atoms/Badge";
import { useUserStore } from "@/store";
import { Avatar, Skeleton } from "@radix-ui/themes";
import useAccess from "@/hooks/useAccess";
import NotificationTabs from "@/components/organisms/Notifcations/index";
import ContextMenu from "../../molecules/ContextMenu/Index";

const UserMenu = () => {
  const currentUser = useUserStore((state) => state.currentUser);

  const handleLogout = async () => {
    try {
      const response = await fetch('/users/sign_out', {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        },
      });

      if (response.ok) {
        window.location.href = '/users/sign_in'; // Logout sonrası yönlendirme
      } else {
        console.error('Logout failed');
      }
    } catch (error) {
      console.error('Unexpected error during logout:', error);
    }
  };

  const menu = [
    { key: "profile", children: "Profile", url: `/profile` },
    /*{ key: "notifications", children: "Notifications", url: "/notifications" },*/
    { key: "logout", children: "Logout", onClick: handleLogout },
  ];

  return currentUser ? (
    <DropdownMenu menu={menu} icon={<ChevronDownIcon className="h-6 w-6" />}>
      <div className="flex gap-3">

        <Avatar
          fallback={`${currentUser?.first_name?.charAt(0)}${currentUser?.last_name?.charAt(0)}`}
          src={currentUser?.avatar_url}
          variant="solid"
          radius="full"
          className="h-8 w-8 lg:h-10 lg:w-10 dark:bg-darkTextColor"
        />
        <div className="flex-col items-start hidden lg:flex text-sm">
          <span className="font-bold">
            {shortenText(currentUser?.name || "")}
          </span>
          <span className="opacity-65">
            {shortenText(currentUser?.title || "")}
          </span>
        </div>
      </div>
    </DropdownMenu>
  ) : (
    <DropdownMenu menu={menu} icon={<ChevronDownIcon className="h-6 w-6" />}>
      <div className="flex gap-3">
        <Skeleton className="h-8 w-8 lg:h-10 lg:w-10" loading />
        <div className="flex-col gap-1.5 items-start justify-center hidden lg:flex text-sm">
          <Skeleton className="h-3.5 w-28" loading />
          <Skeleton className="h-3.5 w-28 opacity-65" loading />
        </div>
      </div>
    </DropdownMenu>
  );
};

const NotificationMenu = () => {

  const NotificationIcon = () => {
    return (
      <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_515_3321)">
          <path d="M10.5882 5.29504H5.29406C4.358 5.29504 3.46028 5.66688 2.79839 6.32878C2.1365 6.99067 1.76465 7.88839 1.76465 8.82445V24.7068C1.76465 25.6429 2.1365 26.5406 2.79839 27.2025C3.46028 27.8644 4.358 28.2362 5.29406 28.2362H21.1764C22.1125 28.2362 23.0102 27.8644 23.6721 27.2025C24.334 26.5406 24.7058 25.6429 24.7058 24.7068V19.4127M17.647 7.05974C17.647 8.46383 18.2048 9.81041 19.1976 10.8033C20.1905 11.7961 21.537 12.3539 22.9411 12.3539C24.3452 12.3539 25.6918 11.7961 26.6846 10.8033C27.6775 9.81041 28.2352 8.46383 28.2352 7.05974C28.2352 5.65566 27.6775 4.30908 26.6846 3.31624C25.6918 2.3234 24.3452 1.76563 22.9411 1.76562C21.537 1.76563 20.1905 2.3234 19.1976 3.31624C18.2048 4.30908 17.647 5.65566 17.647 7.05974Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="23" cy="7" r="6" fill="#F9EE00" />
        </g>
        <defs>
          <clipPath id="clip0_515_3321">
            <rect width="30" height="30" fill="white" />
          </clipPath>
        </defs>
      </svg>

    )
  }

  return (
    <ContextMenu
      content={
        <div>
          <NotificationTabs />
        </div>
      }
    >
      <div className="flex gap-3">
        <Badge.Container content={`${5}`}>
          <NotificationIcon />
        </Badge.Container>
      </div>
    </ContextMenu>

  )
};

const Header = ({ loading }: { loading: boolean }) => {
  const { getAccess } = useAccess();
  
  return (
    <header className="flex items-center gap-5 justify-end px-3 lg:px-5 bg-background h-12 lg:h-16 shadow-md">
      {getAccess(["create_log"]) && (
        <HeaderTimer />
      )}
      <UserMenu />
      {/*<NotificationMenu />*/}

    </header>
  );
};

export default Header;
